<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <div class="row mb-4">
      <div class="col">
        <button
          v-b-tooltip.hover
          title="Voltar"
          @click="$router.push({ path: '/acompanhamento-projetos/listar' })"
          class="btn btn-light border shadow-sm text-dark"
        >
          <font-awesome-icon icon="chevron-left" /> Voltar
        </button>
      </div>
    </div>
    <fcc-adicionar-projeto-form :disabled="false" />
  </div>
</template>
<script>
import fccAdicionarProjetoForm from '../components/fccAdicionarProjetoForm.vue'
import store from '@/store'

export default {
  components: { fccAdicionarProjetoForm },
  data() {
    return {
      titlePage: 'Adicionar Projeto'
    }
  },
  mounted() {
    this.carregaTexto(this.codeMensagem('C01'))

    store
      .dispatch('acompanhamentoDeProjetos/fetchAll', {
        config: this.dadosLoginSession.fccTokenHeaders,
        actions: ['Solicitantes', 'Equipes', 'Sistemas', 'SituacoesProjeto']
      })
      .catch(this.setErrorSystem)
      .finally(this.carregaTexto)
  }
}
</script>